// Anything exported from this file is importable by other in-browser modules.
import apiClient from '../client/api-client'
const PARTNERSHIP = '/partners'
const organizations = '/organizations'
const v1 = 'v1'

export default {
  /**
   * Gets the list of people that have pending invites
   * Now will always include Org Name
   * @return {Promise}       The user's list of pending invites sent
   */
  async getRequestsList() {
    try {
      const { data } = await apiClient.get(`${PARTNERSHIP}/requests/org-view`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },

  async createSherpaRequest(sherpaForm) {
    try {
      const { data } = await apiClient.post(`${PARTNERSHIP}/v2/requests`, sherpaForm)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },

  async fetchOrganizations({ name, physician, state }) {
    try {
      const { data } = await apiClient.get('/organizations/search', {
        params: {
          name,
          physician,
          state
        }
      })
      return data
    } catch (err) {
      throw new Error(err)
    }
  },

  async getSherpaSession() {
    try {
      const {
        data: { sessionRequest = {} }
      } = await apiClient.get(`${PARTNERSHIP}/session-request`)
      return sessionRequest
    } catch (err) {
      return Promise.reject(err)
    }
  },

  async addSherpaSessionData({ sherpaForm }) {
    return apiClient.post(`${PARTNERSHIP}/session-request`, {
      facilities: sherpaForm.selectedProviders || [],
      hasSensitiveRecords: sherpaForm.hasSensitiveRecords || '',
      userProfile: sherpaForm.userProfile || {},
      userPhoneNumber: sherpaForm.userPhoneNumber || '',
      start: sherpaForm.start || null
    })
  },

  async updateSherpaSessionData({ sessionRequestId, sherpaForm }) {
    return apiClient.patch(`${PARTNERSHIP}/session-request/${sessionRequestId}`, {
      facilities: sherpaForm.selectedProviders || [],
      hasSensitiveRecords: sherpaForm.hasSensitiveRecords || '',
      userProfile: sherpaForm.userProfile || {},
      userPhoneNumber: sherpaForm.userPhoneNumber || '',
      textLink: sherpaForm.textLink || ''
    })
  },

  async deleteSherpaSession({ sessionRequestId }) {
    try {
      return apiClient.delete(`${PARTNERSHIP}/session-request/${sessionRequestId}`)
    } catch (err) {
      throw new Error(err)
    }
  },
  async searchGoogleMap({ name, state }) {
    try {
      const { data } = await apiClient.get(`${organizations}/${v1}/search`, {
        params: {
          name,
          state
        }
      })
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  async getHIERequestStatus({ id }) {
    try {
      const { data } = await apiClient.get(`${PARTNERSHIP}/requests/${id}/status`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  }
}
